module.exports = __webpack_public_path__ + "a05fed06f6d5a91169796990e26d1116.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/mystirio.jpg
// module id = 903
// module chunks = 0